<kit-page-header [backgroundWhite]="false"
                 [description]="'Upload files relating to leases to bulk process tenant and lease information'"
                 [fullWidthDescription]="true"
                 [section]="'Leasing Bulk Uploads'"
                 [title]="'Upload lease and tenant information.'"
></kit-page-header>

@if (loading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
  <div class="pb-20-i pb-">Parent Lease: </div>
  <mat-form-field class="custom-select-field" appearance="outline" floatLabel="always">
    <mat-label>Shared Leases</mat-label>
    <mat-select class="custom-select-field-value" placeholder="Select" [formControl]="selectedParentLease">
      <mat-option class="custom-select-field-option" *ngFor="let lease of parentLeases" [value]="lease">{{lease.retailerCompanyName}}</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="pb-20-i" *ngIf="parentLease">
    ( {{displayShortDate(parentLease!.leaseStartDate)}} to {{displayShortDate(parentLease!.leaseEndDate)}} )
  </div>
</div>
<div *ngIf="parentLease && uploadType == 'lease'">
  <app-lease-upload [parentLease]="parentLease"></app-lease-upload>
</div>

<div *ngIf="parentLease && uploadType == 'billing'">
  <app-billing-details-upload [parentLease]="parentLease"></app-billing-details-upload>
</div>


